import type { DrillAction, DrillChip } from '../types.js';

export interface DrillChipsProps {
  readonly chips: readonly DrillChip[];
  readonly onDrill: (action: DrillAction) => void;
  readonly disabled: boolean;
}

/** Component 5 — drill-down chips (pill buttons) that ask the next, narrower question. */
export function DrillChips({ chips, onDrill, disabled }: DrillChipsProps) {
  return (
    <div className="ai-block ai-chips" role="group" aria-label="ریزشدن در پاسخ">
      {chips.map((chip) => (
        <button
          key={chip.id}
          type="button"
          className="sk-btn sk-btn--secondary sk-btn--sm ai-pill"
          disabled={disabled}
          onClick={() => onDrill(chip.action)}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
